
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0fc8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0fc8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("G11q5");

var $aH7VW = parcelRequire("aH7VW");

var $jAgKk = parcelRequire("jAgKk");

var $610Lj = parcelRequire("610Lj");

var $2pPFr = parcelRequire("2pPFr");
const $a560b44cda87dd64$export$b97a28bc344d195e = {
    "is-IS": /^(\+?354)[0-9]{7}$/,
    "am-AM": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7\d{9}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?09[567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+244)\d{9}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[789]\d{6}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38|8)?0\d{9}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
const $a560b44cda87dd64$export$7eb4c4825016ef1e = {
    "+354": /^(\+?354)[0-9]{7}$/,
    "+374": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
    "+971": /^((\+?971)|0)?5[024568]\d{7}$/,
    "+973": /^(\+?973)?(3|6)\d{7}$/,
    "+213": /^(\+?213|0)(5|6|7)\d{8}$/,
    "+961": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "+20": /^((\+?20)|0)?1[0125]\d{8}$/,
    "+964": /^(\+?964|0)?7[0-9]\d{8}$/,
    "+962": /^(\+?962|0)?7[789]\d{7}$/,
    "+965": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "+218": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "+212": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "+968": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "+970": /^(\+?970|0)5[6|9](\d{7})$/,
    "+966": /^(!?(\+?966)|0)?5\d{8}$/,
    "+249": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "+963": /^(!?(\+?963)|0)?9\d{8}$/,
    "+216": /^(\+?216)?[2459]\d{7}$/,
    "+994": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "+3876": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "+375": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "+359": /^(\+?359|0)?8[789]\d{7}$/,
    "+880": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "+376": /^(\+376)?[346]\d{5}$/,
    "+420": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "+45": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "+49": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "+43": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "+41": /^(\+41|0)([1-9])\d{1,9}$/,
    "+352": /^(\+352)?((6\d1)\d{6})$/,
    "+960": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "+30": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "+357": /^(\+?357?)?(9(9|6)\d{6})$/,
    "+1264": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "+61": /^(\+?61|0)4\d{8}$/,
    "+1268": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "+1441": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "+1242": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "+44": /^(\+?44|0)7\d{9}$/,
    "+01481": /^(\+?44|0)1481\d{6}$/,
    "+233": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
    "+592": /^(\+592|0)6\d{6}$/,
    "+852": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "+853": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "+353": /^(\+?353|0)8[356789]\d{7}$/,
    "+91": /^(\+?91|0)?[6789]\d{9}$/,
    "+876": /^(\+?876)?\d{7}$/,
    "+254": /^(\+?254|0)(7|1)\d{8}$/,
    "+236": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "+211": /^(\+?211|0)(9[1257])\d{7}$/,
    "+686": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "+1869": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "+266": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "+356": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "+230": /^(\+?230|0)?\d{8}$/,
    "+265": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "+264": /^(\+?264|0)(6|8)\d{7}$/,
    "+234": /^(\+?234|0)?[789]\d{9}$/,
    "+64": /^(\+?64|0)[28]\d{7,9}$/,
    "+675": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "+92": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "+639": /^(09|\+639)\d{9}$/,
    "+250": /^(\+?250|0)?[7]\d{8}$/,
    "+65": /^(\+65)?[3689]\d{7}$/,
    "+232": /^(\+?232|0)\d{8}$/,
    "+255": /^(\+?255|0)?[67]\d{8}$/,
    "+256": /^(\+?256|0)?[7]\d{8}$/,
    "+1": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "+27": /^(\+?27|0)\d{9}$/,
    "+26": /^(\+?26)?09[567]\d{7}$/,
    "+263": /^(\+263)[0-9]{9}$/,
    "+267": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "+549": /^\+?549(11|[2368]\d)\d{8}$/,
    "+591": /^(\+?591)?(6|7)\d{7}$/,
    "+57": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "+56": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "+506": /^(\+506)?[2-8]\d{7}$/,
    "+53": /^(\+53|0053)?5\d{7}$/,
    "+18": /^(\+?1)?8[024]9\d{7}$/,
    "+504": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "+593": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "+34": /^(\+?34)?[6|7]\d{8}$/,
    "+51": /^(\+?51)?9\d{8}$/,
    "+52": /^(\+?52)?(1|01)?\d{10,11}$/,
    "+505": /^(\+?505)\d{7,8}$/,
    "+507": /^(\+?507)\d{7,8}$/,
    "+595": /^(\+?595|0)9[9876]\d{7}$/,
    "+503": /^(\+?503)?[67]\d{7}$/,
    "+598": /^(\+598|0)9[1-9][\d]{6}$/,
    "+58": /^(\+?58)?(2|4)\d{9}$/,
    "+372": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "+358": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "+679": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "+298": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "+226": /^(\+226|0)[67]\d{7}$/,
    "+229": /^(\+229)\d{8}$/,
    "+243": /^(\+?243|0)?(8|9)\d{8}$/,
    "+237": /^(\+?237)6[0-9]{8}$/,
    "+33": /^(\+?33|0)[67]\d{8}$/,
    "+594": /^(\+?594|0|00594)[67]\d{8}$/,
    "+590": /^(\+?590|0|00590)[67]\d{8}$/,
    "+596": /^(\+?596|0|00596)[67]\d{8}$/,
    "+689": /^(\+?689)?8[789]\d{6}$/,
    "+262": /^(\+?262|0|00262)[67]\d{8}$/,
    "+681": /^(\+681)?\d{6}$/,
    "+972": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "+36": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "+62": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "+98": /^(\+98|0)?9\d{9}$/,
    "+39": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "+378": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "+81": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "+995": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "+7": /^(\+?7|8)?7\d{9}$/,
    "+299": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "+82": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "+996": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
    "+370": /^(\+370|8)\d{8}$/,
    "+371": /^(\+?371)2\d{7}$/,
    "+261": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "+011": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "+959": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "+60": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "+258": /^(\+?258)?8[234567]\d{7}$/,
    "+47": /^(\+?47)?[49]\d{7}$/,
    "+977": /^(\+?977)?9[78]\d{8}$/,
    "+32": /^(\+?32|0)4\d{8}$/,
    "+31": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "+297": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "+48": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "+55": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "+351": /^(\+?351)?9[1236]\d{7}$/,
    "+244": /^(\+244)\d{9}$/,
    "+373": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "+40": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "+94": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "+385": /^(\+385|00385|0)?[1-9]\d{6,8}$/,
    "+386": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "+421": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "+252": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "+355": /^(\+355|0)6[789]\d{6}$/,
    "+381": /^\+381[6-9][0-9]{6,8}$/,
    "+46": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "+992": /^(\+?992)?[5][5]\d{7}$/,
    "+66": /^(\+66|66|0)\d{9}$/,
    "+90": /^(\+?90|0)?5\d{9}$/,
    "+993": /^(\+993|993|8)\d{8}$/,
    "+38": /^(\+?38|8)?0\d{9}$/,
    "+998": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "+84": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "+86": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "+886": /^(\+?886\-?|0)?9\d{8}$/,
    "+975": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "+9677": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "+2120": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "+93": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
function $a560b44cda87dd64$export$8f24708ca33d8a54(str) {
    return str.split("").map((char, index)=>(index + 1) % 3 === 0 ? char + " " : char).join("");
}


const $371bfc0e78cd1f84$var$registerForm = document.querySelector("#formRegister");
/**
 * Handle the form submission.
 */ $371bfc0e78cd1f84$var$registerForm?.addEventListener("submit", async (e)=>{
    // Get form data
    e.preventDefault();
    const formData = new FormData(e.target, e.submitter);
    const formDataEntries = Object.fromEntries(formData);
    const formRef = e.target;
    // Clear existing validation errors
    (0, $jAgKk.clearValidationErrors)(formRef);
    // Our form has two steps. We need to know if the user clicked on the "save and continue" button or the "finish" button.
    const steps = Array.from(formRef.querySelectorAll("[data-step]"));
    const isFirstStep = steps.some((x)=>x.classList.contains("active") && x.getAttribute("data-step") === "1");
    try {
        if (isFirstStep) {
            const safeParse = await $371bfc0e78cd1f84$var$RegisterSchema.safeParseAsync(formDataEntries);
            if (safeParse.success) {
                /**
         * If the first step is valid, we can continue to the second step.
         */ localStorage.removeItem((0, $2pPFr.EMAIL_PREFILL_LOCAL_STORAGE_KEY));
                return (0, $610Lj.goToFormStep)(formRef, 2, 'input[name="password"]');
            } else {
                const issuePaths = safeParse.error.issues?.flatMap((issue)=>issue.path);
                const firstStepPaths = [
                    "email",
                    "firstName",
                    "lastName"
                ];
                if (!issuePaths.some((path)=>firstStepPaths.includes(String(path)))) {
                    (0, $610Lj.setLoadingState)(formRef, false);
                    /**
           * If the issues don't include any of the first step fields, we can continue to the second step.
           */ return (0, $610Lj.goToFormStep)(formRef, 2, 'input[name="password"]');
                } else {
                    (0, $610Lj.setLoadingState)(formRef, false);
                    (0, $jAgKk.displayValidationErrors)(formRef, safeParse.error, firstStepPaths);
                }
            }
        } else {
            (0, $610Lj.setLoadingState)(formRef, true);
            const parsed = await $371bfc0e78cd1f84$var$RegisterSchema.parseAsync(formDataEntries);
            const inputIn = new FormData();
            inputIn.append("email", parsed.email);
            if (parsed.password) inputIn.append("password", parsed.password);
            inputIn.append("first_name", parsed.firstName);
            inputIn.append("last_name", parsed.lastName);
            if (parsed.phone) {
                inputIn.append("phone_prefix", parsed.phoneNumberPrefix);
                inputIn.append("phone", parsed.phone);
            }
            if (parsed.favouritePlayer) inputIn.append("favourite_player", parsed.favouritePlayer);
            if (parsed.gender) inputIn.append("gender", parsed.gender);
            inputIn.append("language", (0, $610Lj.inputLanguageFromLocale)((0, $jAgKk.currentLocale)()));
            inputIn.append("birthday", (0, $610Lj.simpleIsoDateFromSelect)(parsed.day, parsed.month, parsed.year));
            if (parsed.marketing) inputIn.append("marketing", "on");
            if ($371bfc0e78cd1f84$var$registerForm) (0, $610Lj.simulateFormAction)(inputIn, $371bfc0e78cd1f84$var$registerForm);
        }
    } catch (error) {
        if (error instanceof $aH7VW.ZodError) (0, $jAgKk.displayValidationErrors)(formRef, error);
        else (0, $610Lj.Notifications).createErrorToast(error, "Register page form submit error:");
        (0, $610Lj.setLoadingState)(formRef, false);
    }
});
/**
 * Handle the click on the "previous step" button.
 */ const $371bfc0e78cd1f84$var$prevStepButton = document.querySelector(".nav__previous");
$371bfc0e78cd1f84$var$prevStepButton?.addEventListener("click", (e)=>{
    const formRef = document.querySelector("#formRegister");
    const firstFormStepWrapper = formRef?.querySelector('[data-step="1"]');
    // If we are not on the first step, go back to the first step.
    if (!firstFormStepWrapper?.classList.contains("active")) {
        e.preventDefault();
        if (formRef) return (0, $610Lj.goToFormStep)(formRef, 1);
    }
});
/**
 * Initial page load actions.
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const emailInput = $371bfc0e78cd1f84$var$registerForm?.querySelector('input[name="email"]');
    const firstNameInput = $371bfc0e78cd1f84$var$registerForm?.querySelector('input[name="firstName"]');
    const lastNameInput = $371bfc0e78cd1f84$var$registerForm?.querySelector('input[name="lastName"]');
    const phonePrefixSelect = $371bfc0e78cd1f84$var$registerForm?.querySelector('select[name="phoneNumberPrefix"]');
    const genderSelect = $371bfc0e78cd1f84$var$registerForm?.querySelector('select[name="gender"]');
    /**
   * Prefill email input if it's in the local storage or passed to hbs.
   */ if (emailInput) {
        const emailPrefillValue = localStorage.getItem((0, $2pPFr.EMAIL_PREFILL_LOCAL_STORAGE_KEY));
        if (emailPrefillValue) emailInput.value = emailPrefillValue;
        const emailDefaultValue = (0, $610Lj.parseDefaultValue)(emailInput.getAttribute((0, $2pPFr.DATA_DEFAULT_ATTRIBUTE)));
        if (emailDefaultValue) emailInput.value = emailDefaultValue;
    }
    /**
   * Prefill first name input if it's  passed to hbs.
   */ if (firstNameInput) {
        const nameDefaultValue = (0, $610Lj.parseDefaultValue)(firstNameInput.getAttribute((0, $2pPFr.DATA_DEFAULT_ATTRIBUTE)));
        if (nameDefaultValue) firstNameInput.value = nameDefaultValue;
    }
    /**
   * Prefill last name input if it's  passed to hbs.
   */ if (lastNameInput) {
        const surnameDefaultValue = (0, $610Lj.parseDefaultValue)(lastNameInput.getAttribute((0, $2pPFr.DATA_DEFAULT_ATTRIBUTE)));
        if (surnameDefaultValue) lastNameInput.value = surnameDefaultValue;
    }
    /**
   * Prefill gender select if it's  passed to hbs.
   */ if (genderSelect) {
        const genderDefaultValue = (0, $610Lj.parseDefaultValue)(genderSelect.getAttribute((0, $2pPFr.DATA_DEFAULT_ATTRIBUTE)));
        if (genderDefaultValue) genderSelect.value = genderDefaultValue;
    }
    if (phonePrefixSelect) {
        const prefixKeys = Object.keys((0, $a560b44cda87dd64$export$7eb4c4825016ef1e)).filter((prefix)=>prefix !== "+420" && prefix !== "+421").sort((a, b)=>{
            const numberA = Number(a.replace("+", ""));
            const numberB = Number(b.replace("+", ""));
            return numberA - numberB;
        });
        phonePrefixSelect.setAttribute("data-selected", "true");
        const czSkOptGroup = document.createElement("optgroup");
        czSkOptGroup.label = "\u010Cesko/Slovensko";
        czSkOptGroup.appendChild(new Option("+420", "+420", true));
        czSkOptGroup.appendChild(new Option("+421", "+421"));
        phonePrefixSelect.appendChild(czSkOptGroup);
        const othersOptGroup = document.createElement("optgroup");
        othersOptGroup.label = (0, $jAgKk.t)("pages.common.others");
        othersOptGroup.setAttribute("data-i18n", "pages.common.others");
        othersOptGroup.setAttribute("i18n-target", "label");
        prefixKeys.forEach((prefix)=>{
            othersOptGroup.appendChild(new Option(prefix, prefix));
        });
        phonePrefixSelect.appendChild(othersOptGroup);
    }
    $371bfc0e78cd1f84$var$populateDatepickerSelects({
        setDefault: true
    });
});
document.addEventListener("SpartaAuthLocaleChanged", ()=>{
    /**
   * We want to update month select on locale change.
   */ $371bfc0e78cd1f84$var$populateMonthSelect(true);
});
function $371bfc0e78cd1f84$var$populateDatepickerSelects(options) {
    const datepickerDefaultValue = $371bfc0e78cd1f84$var$registerForm?.querySelector(".date-of-birth")?.getAttribute((0, $2pPFr.DATA_DEFAULT_ATTRIBUTE));
    const [defaultYear, defaultMonth, defaultDay] = ((0, $610Lj.parseDefaultValue)(datepickerDefaultValue)?.split("-") ?? []).map((x)=>Number(x));
    const daySelect = $371bfc0e78cd1f84$var$registerForm?.querySelector('select[name="day"]');
    const yearSelect = $371bfc0e78cd1f84$var$registerForm?.querySelector('select[name="year"]');
    /**
   * Populate the day select
   */ if (daySelect) {
        const selectedIndex = daySelect?.selectedIndex;
        // Reset previous options
        daySelect.innerHTML = '<option selected value=""></option>';
        // Populate the day select
        for(let day = 1, i = 0; day <= 31; day++, i++)daySelect?.options.add(new Option(String(day), String(day), selectedIndex === i));
        if (options?.setDefault && defaultDay) {
            daySelect.value = String(defaultDay);
            daySelect.setAttribute("data-selected", "true");
        }
    }
    /**
   * Populate the month select
   */ $371bfc0e78cd1f84$var$populateMonthSelect(false, options?.setDefault ? defaultMonth : undefined);
    /**
   * Populate the year select
   */ if (yearSelect) {
        const selectedIndex = yearSelect?.selectedIndex;
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 140;
        const maxYear = currentYear - 14;
        // Reset previous options
        yearSelect.innerHTML = '<option selected value=""></option>';
        // Populate the year select
        for(let year = maxYear, i = 0; year >= minYear; year--, i++)yearSelect?.options.add(new Option(String(year), String(year), selectedIndex === i));
        if (options?.setDefault && defaultYear) {
            yearSelect.value = String(defaultYear);
            yearSelect.setAttribute("data-selected", "true");
        }
    }
}
/**
 * Populates the month select element with options.
 * @param preserveSelected - Whether to preserve the selected month.
 */ function $371bfc0e78cd1f84$var$populateMonthSelect(preserveSelected, defaultMonth) {
    const monthSelect = $371bfc0e78cd1f84$var$registerForm?.querySelector('select[name="month"]');
    const selectedIndex = monthSelect?.selectedIndex;
    if (monthSelect) {
        // Reset previous options
        monthSelect.innerHTML = '<option selected value=""></option>';
        // Populate the month select
        (0, $610Lj.getI18nMonths)().forEach((monthItem, i)=>{
            monthSelect?.options.add(new Option(monthItem.label, String(monthItem.monthIndex + 1), monthSelect.selectedIndex === i));
        });
        // Preserve the selected month
        if (selectedIndex && preserveSelected) monthSelect.selectedIndex = selectedIndex;
        if (defaultMonth) {
            monthSelect.value = String(defaultMonth);
            monthSelect.setAttribute("data-selected", "true");
        }
    }
}
const $371bfc0e78cd1f84$var$formGroupsWithBlurPlaceholder = document.querySelectorAll(".form-group[data-focused]");
Array.from($371bfc0e78cd1f84$var$formGroupsWithBlurPlaceholder).forEach((formGroup)=>{
    const input = formGroup.querySelector("input");
    const blurPlaceholder = formGroup.querySelector(".blur-placeholder");
    formGroup.setAttribute("data-empty", String(!input?.value?.trim()));
    if (blurPlaceholder) blurPlaceholder.textContent = (0, $a560b44cda87dd64$export$8f24708ca33d8a54)(input?.value?.trim() ?? "");
    input?.addEventListener("blur", (e)=>{
        if (blurPlaceholder) blurPlaceholder.textContent = (0, $a560b44cda87dd64$export$8f24708ca33d8a54)(input?.value?.trim() ?? "");
        formGroup.setAttribute("data-focused", "false");
        formGroup.setAttribute("data-empty", String(!e.target?.value?.trim()));
    });
    input?.addEventListener("focus", ()=>{
        formGroup.setAttribute("data-focused", "true");
    });
});
const $371bfc0e78cd1f84$var$stringWithoutEmoji = $aH7VW.string().regex(/^((?!\p{Emoji_Presentation}).)*$/u, (0, $jAgKk._t)("validations.emojiNotAllowed"));
const $371bfc0e78cd1f84$var$requiredStringWithoutEmoji = $aH7VW.string({
    required_error: (0, $jAgKk._t)("validations.required")
}).regex(/^((?!\p{Emoji_Presentation}).)*$/u, (0, $jAgKk._t)("validations.emojiNotAllowed"));
/**
 * Validation schema for the register form.
 */ const $371bfc0e78cd1f84$var$emailSchema = $aH7VW.string().email({
    message: (0, $jAgKk._t)("validations.email")
});
const $371bfc0e78cd1f84$var$RegisterPasswordSchema = $aH7VW.object({
    sso_registration: $aH7VW.string().optional(),
    password: $371bfc0e78cd1f84$var$stringWithoutEmoji.optional(),
    passwordAgain: $371bfc0e78cd1f84$var$stringWithoutEmoji.optional()
}).superRefine((val, ctx)=>{
    // We need to check if user uses SSO register flow
    // and add password validations only if he doesn't
    if (!val.sso_registration || val.sso_registration === "false" || val.sso_registration === "{{sso_registration}}") {
        if (!val.password) {
            ctx.addIssue({
                message: (0, $jAgKk._t)("validations.required"),
                path: [
                    "password"
                ],
                code: $aH7VW.ZodIssueCode.custom,
                fatal: true
            });
            return $aH7VW.NEVER;
        }
        if (val.password) {
            if (val.password?.length < 6) {
                ctx.addIssue({
                    message: (0, $jAgKk._t)("validations.minLength"),
                    minimum: 6,
                    path: [
                        "password"
                    ],
                    code: $aH7VW.ZodIssueCode.too_small,
                    type: "string",
                    inclusive: false,
                    fatal: true
                });
                return $aH7VW.NEVER;
            }
            if (val.password?.length > 30) ctx.addIssue({
                message: (0, $jAgKk._t)("validations.maxLength"),
                maximum: 30,
                path: [
                    "password"
                ],
                code: $aH7VW.ZodIssueCode.too_big,
                type: "string",
                inclusive: false,
                fatal: true
            });
        }
        if (!val.passwordAgain) {
            ctx.addIssue({
                message: (0, $jAgKk._t)("validations.required"),
                path: [
                    "passwordAgain"
                ],
                code: $aH7VW.ZodIssueCode.custom,
                fatal: true
            });
            return $aH7VW.NEVER;
        }
        if (val.passwordAgain) {
            if (val.passwordAgain?.length < 6) ctx.addIssue({
                message: (0, $jAgKk._t)("validations.minLength"),
                minimum: 6,
                path: [
                    "passwordAgain"
                ],
                code: $aH7VW.ZodIssueCode.too_small,
                type: "string",
                inclusive: false,
                fatal: true
            });
            if (val.passwordAgain?.length > 30) ctx.addIssue({
                message: (0, $jAgKk._t)("validations.maxLength"),
                maximum: 30,
                path: [
                    "passwordAgain"
                ],
                code: $aH7VW.ZodIssueCode.too_big,
                type: "string",
                inclusive: false,
                fatal: true
            });
        }
        if (val.password !== val.passwordAgain) ctx.addIssue({
            message: (0, $jAgKk._t)("validations.passwordsDontMatch"),
            path: [
                "passwordAgain"
            ],
            code: $aH7VW.ZodIssueCode.custom
        });
        if (val.password && val.passwordAgain) {
            if (!/[A-Z]/.test(val.password) || !/[a-z]/.test(val.password) || !/\d/.test(val.password)) ctx.addIssue({
                message: (0, $jAgKk._t)("validations.passwordRequirements"),
                path: [
                    "password"
                ],
                code: $aH7VW.ZodIssueCode.custom
            });
            return $aH7VW.NEVER;
        }
    }
});
// And we need to use intersection so the password refinements are triggered with base schema cycle
const $371bfc0e78cd1f84$var$RegisterSchema = $aH7VW.intersection($aH7VW.object({
    email: $371bfc0e78cd1f84$var$emailSchema.refine(async (email)=>{
        if (email && $371bfc0e78cd1f84$var$emailSchema.safeParse(email).success) {
            const response = await fetch(`/v1/users/exists?email=${encodeURIComponent(email)}`);
            return response.status === 404;
        } else return true;
    }, {
        message: (0, $jAgKk._t)("validations.emailIsUsed")
    }),
    firstName: $371bfc0e78cd1f84$var$requiredStringWithoutEmoji.min(1, {
        message: (0, $jAgKk._t)("validations.required")
    }).max(50, {
        message: (0, $jAgKk._t)("validations.maxLength")
    }),
    lastName: $371bfc0e78cd1f84$var$requiredStringWithoutEmoji.min(1, {
        message: (0, $jAgKk._t)("validations.required")
    }).max(50, {
        message: (0, $jAgKk._t)("validations.maxLength")
    }),
    phoneNumberPrefix: $aH7VW.string(),
    phone: $aH7VW.union([
        $aH7VW.string().length(0),
        $aH7VW.string().min(4, {
            message: (0, $jAgKk._t)("validations.required")
        }),
        $aH7VW.string().max(20, {
            message: (0, $jAgKk._t)("validations.maxLength")
        })
    ]).optional().transform((e)=>e === "" ? undefined : e),
    favouritePlayer: $aH7VW.string().optional(),
    gender: $aH7VW.string().optional(),
    day: $aH7VW.string().min(1, {
        message: (0, $jAgKk._t)("validations.required")
    }),
    month: $aH7VW.string().min(1, {
        message: (0, $jAgKk._t)("validations.required")
    }),
    year: $aH7VW.string().min(1, {
        message: (0, $jAgKk._t)("validations.required")
    }),
    marketing: $aH7VW.string().transform((value)=>value === "on").optional(),
    terms: $aH7VW.string({
        required_error: (0, $jAgKk._t)("validations.required")
    }).transform((value)=>value === "on")
}).refine((data)=>(0, $610Lj.isValidSelectDate)(data.day, data.month, data.year), {
    path: [
        "day"
    ],
    message: (0, $jAgKk._t)("validations.invalidDate")
}).refine((data)=>(0, $610Lj.matchesMinAge)(data.day, data.month, data.year, 15), {
    path: [
        "day"
    ],
    message: (0, $jAgKk._t)("validations.minAge"),
    params: {
        minimum: 15
    }
}).refine((data)=>$371bfc0e78cd1f84$var$isValidPhoneNumber(data.phoneNumberPrefix, data.phone), {
    path: [
        "phone"
    ],
    message: (0, $jAgKk._t)("validations.invalidPhone")
}), $371bfc0e78cd1f84$var$RegisterPasswordSchema);
function $371bfc0e78cd1f84$var$isValidPhoneNumber(prefix, phoneNumber) {
    if (!phoneNumber) return true;
    let phone = phoneNumber;
    if (phone.startsWith(prefix)) phone = phone.replace(prefix, "");
    const match = (0, $a560b44cda87dd64$export$7eb4c4825016ef1e)[prefix];
    if (!match) throw new Error(`Unhandled prefix: ${prefix}. Please add validation for this prefix.`);
    const result = match.test(prefix + phone);
    return result;
}


//# sourceMappingURL=register.a4c04069.js.map
